import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Jakarta')

const moment_ = moment;

export default {
	data() {
		return {
			moment: moment_
		}
	}
}